// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_RECENT_BLOG_ARTICLES_SHOW_MORE = "Viac nov\u00fdch \u010dl\u00e1nkov...";
export const LOAD_ERROR_MESSAGE = "Nepodarilo sa na\u010d\u00edta\u0165 obsah";
export const STROLLEROPEDIA_NEW_ARTICLES = "Najnov\u0161ie \u010dl\u00e1nky";
